import React, { PropTypes } from 'react'
import { Form } from 'react-redux-form/immutable'
import { Fieldset, Row, Field } from 'react-gridforms'
import Input from 'bisu-react-input'

const FormHeader  = ({ data }) => {
  let status = (
    <div>
      Status: <span className="text-warning">Pending</span>
    </div>
  )
  if (data.get('registered_date')) {
    status = (
      <div>
        Status: <span className="text-success">Registered ({data.get('registered_date')})</span>
      </div>
    )
  }
  return (
    <Form model="billingHeaderState" className="grid-form">
      <Fieldset legend={status} disabled>
        <Row>
          <Field>
            <Input model=".student_id" label="Student ID" />
          </Field>
          <Field span="3">
            <Input model=".student_name" label="Student Name" />
          </Field>
        </Row>
        <Row>
          <Field span="2">
            <Input
              model=".course_code"
              label="Course/Major"
            />
          </Field>
          <Field span="1">
            <Input
              model=".level"
              label="Year Level"
            />
          </Field>
          <Field span="1">
            <Input
              model=".college_code"
              label="College"
            />
          </Field>
          <Field span="2">
            <Input
              model=".scholarship_code"
              label="Scholarship"
              disabled
            />
          </Field>
          <Field span="1">
            <Input
              model=".sex"
              label="Sex"
            />
          </Field>
        </Row>
      </Fieldset>
    </Form>
  )
}

FormHeader.propTypes = {
  data: PropTypes.object,
}

export default FormHeader



// WEBPACK FOOTER //
// ./src/containers/Billing/form-header.js